import { DateTime } from 'luxon';

export const startOfDay = (dateTime: DateTime): DateTime => {
    return dateTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
}

/**
 * Gets the start of Sunday at midnight for the week containing the given date time.
 * If the given dateTime is on Sunday it returns midnight in the morning of the given day.
 * @param {DateTime} dateTime to get Sunday before/on for.
 * @returns {DateTime} Sunday at midnight (in the morning)
 */
export const getWeekStart = (dateTime: DateTime): DateTime => {
    // Luxon considers weeks to start on Monday per ISO 8601 so 7 is Sunday (Start of Week) otherwise subtract 1 day to get Sunday-based Day of Week
    if (dateTime.weekday !== 7) {
        dateTime = dateTime.startOf('week').minus({ day: 1 });
    }
    return startOfDay(dateTime);
}

/**
 * @param {DateTime} dateTime to get 23:59:59.999 for
 * @returns {DateTime} given day at 23:59:59.999
 */
export const getEndOfDay = (dateTime: DateTime): DateTime => {
    return dateTime.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
}

/**
 * Gets the end of day (23:59:59.999) Saturday for the week containing the given date time.
 * If the given dateTime is on Saturday it returns 23:59:59.999 of the given day.
 * @param {DateTime} weekStart to get Saturday at 23:59:59.999 after/on for.
 * @returns {DateTime} Saturday at 23:59:59.999 PM
 */
export const getWeekEnd = (weekStart: DateTime): DateTime => {
    return getEndOfDay(weekStart.plus({ days: 6 }));
}

export const formatWeekTitle = (dateTime: DateTime, weekEndDate: number): string => {
    return dateTime.toFormat(`MMMM d - '${weekEndDate}', yyyy`)
}

export const formatDayTitle = (dateTime: DateTime): string => {
    return dateTime.toFormat('EEEE - MMM d');
}